import type { RouteRecordRaw } from 'vue-router';

export const TRANSACTION_ROUTER: RouteRecordRaw[] = [
  {
    path: '/inventory/transaction',
    component: () => import('@/components/layout/Default.vue'),
    meta: { requiresAuth: true },
    redirect: '/inventory/transaction/list',
    children: [
      {
        path: 'list',
        component: () => import('@/modules/inventory/transaction/views/List.vue'),
        name: 'Transaction List',
        meta: {
          title: '재고수불부',
        },
      },
    ],
  },
];
